<div class="calculation-table-row">
  <table>
    <tr>
      <td class="period annual-rent-period">
        <span i18n>Period</span> {{ (+feeAnnualRentPeriodIndex) + 1 }}
      </td>
      <td class="period-details annual-rent-period">
        <form [formGroup]="feeAnnualRentPeriodForm">
          <table>
            <tr>
              <td class="rentincrease">
                <div class="formfields">
                  <div class="formfields__container">
                    <iv-decimal-field
                      [suffix]="'%'"
                      [customStyles]="{color: 'rgb(116, 116, 116)'}"
                      controlName="rent_increase_{{feeAnnualRentPeriodIndex}}"
                      [formControl]="feeAnnualRentPeriodForm.get('rent_increase')"
                      [disabled]="disableInput('rent_increase', feeAnnualRentPeriodIndex) || disabled"
                    ></iv-decimal-field>
                  </div>
                </div>
              </td>
              <td class="symbol-multiply"></td>
              <td class="annualrent">
                <div class="formfields">
                  <div class="formfields__container">
                    <iv-currency-field
                      controlName="annual_rent_{{feeAnnualRentPeriodIndex}}"
                      [formControl]="feeAnnualRentPeriodForm.get('annual_rent')"
                      [currency]="currencySymbol"
                      [prefixed]="true"
                      [customStyles]="{color: 'rgb(116, 116, 116)'}"
                      [disabled]="disableInput('annual_rent', feeAnnualRentPeriodIndex) || disabled">
                    </iv-currency-field>
                    <span class="unit-measurement">/{{ feeAnnualRentPeriod.size_measurement }}</span>
                  </div>
                </div>
              </td>
              <td class="symbol-plus"></td>
              <td class="annualoutgoing">
                <div class="formfields">
                  <div class="formfields__container">
                    <iv-currency-field
                      controlName="annual_outgoing_{{feeAnnualRentPeriodIndex}}"
                      [formControl]="feeAnnualRentPeriodForm.get('annual_outgoing')"
                      [currency]="currencySymbol"
                      [prefixed]="true"
                      [customStyles]="{color: 'rgb(116, 116, 116)'}"
                      [disabled]="disableInput('annual_outgoing', feeAnnualRentPeriodIndex, outgoings) || disabled">
                    </iv-currency-field>
                    <span class="unit-measurement">/{{ feeAnnualRentPeriod.size_measurement }}</span>
                  </div>
                </div>
              </td>
              <td class="symbol-multiply"></td>
              <td class="month">
                <div class="formfields">
                  <div class="formfields__container">
                    <mat-form-field floatPlaceholder="never">
                      <input
                        id="months_{{feeAnnualRentPeriodIndex}}"
                        formControlName="months"
                        matInput
                        type="number"
                        min="0"
                        max="12"
                        [ngStyle]="{color: 'rgb(116, 116, 116)'}">
                    </mat-form-field>
                  </div>
                </div>
              </td>
              <td class="symbol-plus"></td>
              <td class="annualcarpark">
                <div class="formfields">
                  <div class="formfields__container">
                    <iv-currency-field
                      controlName="annual_car_park_{{feeAnnualRentPeriodIndex}}"
                      [formControl]="feeAnnualRentPeriodForm.get('annual_car_park')"
                      [currency]="currencySymbol"
                      [prefixed]="true"
                      [customStyles]="{color: 'rgb(116, 116, 116)'}"
                      [disabled]="disableInput('annual_car_park', feeAnnualRentPeriodIndex) || disabled">
                    </iv-currency-field>
                  </div>
                </div>
              </td>
              <td class="symbol-minus"></td>
              <td class="incentives">
                <div class="formfields">
                  <div class="formfields__container">
                    <mat-form-field
                      floatPlaceholder="never"
                      [matTooltip]="getTooltip('incentive', 'number')">
                      <span matPrefix>{{ currencySymbol }}</span>
                      <input
                        formControlName="incentive"
                        id="incentives_{{feeAnnualRentPeriodIndex}}"
                        matInput
                        type="text"
                        [ngStyle]="{color: 'rgb(116, 116, 116)'}">
                        <button (click)="redirectToPropertyPage()" type="button" mat-icon-button matSuffix [disabled]="disabled">
                          <mat-icon color="primary">mode_edit</mat-icon>
                        </button>
                    </mat-form-field>
                  </div>
                </div>
              </td>
              <td class="propertysize">
                {{ (calculationMetricCondition === 'size' ? feeAnnualRentPeriod.property_size : feeAnnualRentPeriod[calculationMetricCondition]) | number: '.0-2' }}
              </td>
              <td class="transaction">{{ feeAnnualRentPeriod?.annual_transaction_amount | customCurrency:currencyLabel:'symbol-narrow' }}</td>
              <td class="feerate">
                <div class="formfields">
                  <div class="formfields__container">
                    <iv-decimal-field
                      [suffix]="getFeeRateSuffix()"
                      [customStyles]="{color: 'rgb(116, 116, 116)'}"
                      controlName="fee_rate_{{feeAnnualRentPeriodIndex}}"
                      [formControl]="feeAnnualRentPeriodForm.get('fee_rate')"
                      [disabled]="disabled"
                      [integerLimit]="3"
                    ></iv-decimal-field>
                  </div>
                </div>
              </td>
              <td class="symbol-equivalent"></td>
              <td class="grossfees">{{ feeAnnualRentPeriod?.annual_cbre_fee | customCurrency:currencyLabel:'symbol-narrow' }}</td>
              <td class="delete">
                <iv-delete
                  *ngIf="!disabled"
                  [disabled]="disableDeleteButton()"
                  [identifier]="feeAnnualRentPeriod?.id"
                  (deleteEvent)="deleteFeeAnnualRentPeriod.emit($event)">
                </iv-delete>
              </td>
            </tr>
          </table>
        </form>
      </td>
    </tr>
  </table>
</div>
